import { Component, type PropsWithChildren } from "react";

import { logDevError } from "./log-dev-error";
import { GenericErrorPage } from "../types/GenericErrorPage";

type ErrorBoundaryState = {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
};

export type ErrorBoundryProps = PropsWithChildren<{
  handleGoToAppDashboard?: () => void;
}>;

const initialState: ErrorBoundaryState = {
  error: null,
  errorInfo: null,
};

export class GenericErrorBoundry extends Component<ErrorBoundryProps, ErrorBoundaryState> {
  boundryName: string;
  constructor(props: ErrorBoundryProps) {
    super(props);
    this.boundryName = "GenericErrorBoundry";
    this.state = initialState;
    this.reset = this.reset.bind(this);
  }

  reset() {
    this.setState(initialState);
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logDevError(error, info, this.boundryName);
    this.setState({ errorInfo: info });
  }

  render() {
    if (this.state.error) {
      return (
        <GenericErrorPage
          onDismissError={this.reset}
          error={this.state.error}
          errorInfo={this.state.errorInfo}
          boundaryName={this.boundryName}
          handleGoToAppDashboard={this.props.handleGoToAppDashboard}
        />
      );
    }

    return this.props.children;
  }
}
